module.exports = __webpack_public_path__ + "img/cover_wibo_2.711b81be.jpg";